import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/referrals";
const FALLBACK_MESSAGE = "\u062e\u0637\u0627 \u062f\u0631 \u062f\u0631\u06cc\u0627\u0641\u062a \u0627\u0637\u0644\u0627\u0639\u0627\u062a \u0647\u0645\u06a9\u0627\u0631\u06cc";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getReferral() {
  return request("/referral/");
}
